class HistoryTrackingBase {
  constructor (modifiedDate, modifiedByHsaId, modifiedByName) {
    this.modifiedDate = modifiedDate
    this.modifiedByHsaId = modifiedByHsaId
    this.modifiedByName = modifiedByName
  }
}

export default HistoryTrackingBase
